// extracted by mini-css-extract-plugin
export default {"ModalForm":"ModalForm_ModalForm__1ZEXD","ModalFormIcon":"ModalForm_ModalFormIcon__Jjqm4"};